import React from "react"
import { Redirect } from "react-router-dom"

// Profile
import UserProfile from "../pages/Authentication/user-profile"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"
import LockScreen from "../pages/Authentication/LockScreen"
import RoleView from "pages/Roles/RoleView"
import UserView from "pages/User/UserView"
import CarParkView from "pages/CarPark/CarParkView"
import SeasonPassVIew from "pages/SeasonPass/SeasonPassVIew"
import GuestView from "pages/guest/GuestView"
import UserApproval from "pages/User/UserApproval"
import GuestApproval from "pages/guest/GuestApproval"
import UserDetailChangeApproval from "pages/User/UserChangeApproval"
import AuditTicketView from "pages/Tickets/AuditTicketView"
import BillView from "pages/Bill/BillView"
import BlacklistView from "pages/Blacklist/BlacklistView"
// Dashboard
import Dashboard from "../pages/Dashboard/index"
import CarparkTicketView from "pages/Tickets/CarparkTicketView"
import SystemSetting from "pages/SystemSetting"
// import ManageAdmins from "pages/ManageAdmins";
import AdminView from "pages/Admin/AdminView"
import Dashboards from "pages/Dashboards"
import Pages404 from "pages/error404"
import SpecialDates from "pages/SpecialDates"
import BillingPage from "pages/Bill/BillingPage"
import GuestComplimentary from "pages/GuestComplimentary/GuestComplimentary"
import OccupancyRateView from "pages/Tickets/OccupancyRateView"

const authProtectedRoutes = [
  // Dashboard
  { path: "/dashboard", module: "dashboard", component: Dashboards },

  // //profile
  { path: "/profile", module: "manage_admins", component: UserProfile },

  // Manage Roles
  { path: "/roles", module: "manage_roles", component: RoleView },

  // Manage Users
  { path: "/users", module: "manage_users", component: UserView },

  // Manage Carpark
  { path: "/carparks", module: "manage_carparks", component: CarParkView },

  // Manage Season Passes
  {
    path: "/season-passes",
    module: "manage_season_passes",
    component: SeasonPassVIew,
  },

  // Manage Guests
  { path: "/guests", module: "manage_guest", component: GuestView },

  //Manage User Approval
  {
    path: "/user-approvals",
    module: "manage_approval",
    component: UserApproval,
  },

  //Manage Guest Approval
  {
    path: "/guest-approvals",
    module: "manage_approval",
    component: GuestApproval,
  },

  //Manage Detail Change Approval
  {
    path: "/details-change-approvals",
    module: "manage_approval",
    component: UserDetailChangeApproval,
  },

  //Audit Tickets
  { path: "/audit-tickets", module: "tickets", component: AuditTicketView },

  //Carpark Tickets
  {
    path: "/carpark-tickets",
    module: "tickets",
    component: CarparkTicketView,
  },

  //Occupancy Rate
  {
    path: "/occupancy-rate",
    module: "tickets",
    component: OccupancyRateView,
  },

  //Bills
  { path: "/bills", module: "manage_bills", component: BillView },

  //BillingPage
  { path: "/billingPage", module: "billing_page", component: BillingPage },

  
  //Blacklists
  { path: "/blacklists", module: "manage_blacklists", component: BlacklistView },


  // System Settings
  {
    path: "/system-settings",
    module: "system_settings",
    component: SystemSetting,
  },

  // Special Dates
  {
    path: "/special-dates",
    module: "manage_special_dates",
    component: SpecialDates,
  },

  // Manage Admins
  { path: "/manage-admins", module: "manage_admins", component: AdminView },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    module: "dashboard",
    component: () => <Redirect to="/dashboard" />,
  },
]

const publicRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/grantcomplimentaryaccess", component: GuestComplimentary },
  { path: "/register", component: Register },
  { path: "/auth-lock-screen", component: LockScreen },
  { path: "/exception/403", component: Pages404 },
]

export { authProtectedRoutes, publicRoutes }
